<template>
  <div ref="dom" class="charts chart-bar"></div>
</template>

<script>
import * as echarts from "echarts";
import { on, off } from "@/libs/tools";
export default {
  name: "ChartBar",
  props: {
    value: Array,
    text: String,
    subtext: String,
  },
  data() {
    return {
      dom: null,
    };
  },
  watch: {
    value: {
      handler(val) {
        // console.log(val);
        this.loadEcharts(val);
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {},
  methods: {
    resize() {
      this.dom.resize();
    },
    loadEcharts(val) {
      this.$nextTick(() => {
        let xAxisData = val.map((item) => item.collegeName || item.majorName);
        let seriesData01 = val.map((item) => item.level1);
        let seriesData02 = val.map((item) => item.level2);
        let seriesData03 = val.map((item) => item.level3);
        let seriesData04 = val.map((item) => item.level4);
        let option = {
          grid: {
            left: "3%",
            right: "3%",
            top: "10%",
            bottom: "10%",
            containLabel: true,
          },
          tooltip: {
            trigger: "axis",
            axisPointer: {
              // 坐标轴指示器，坐标轴触发有效
              type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
            },
          },
          legend: {
            show: true,
            icon: "circle",
            right: "3%",
            top: "0",
            background: "#fff",
            shadowBlur: {
              shadowColor: "rgba(0, 0, 0, 0.5)",
              shadowBlur: 10,
            },
          },
          xAxis: [
            {
              type: "category",
              boundaryGap: true,
              show: true,
              axisTick: {
                show: false,
              },
              splitLine: {
                show: false,
                lineStyle: {
                  // type: "dashed",
                  // 使用深浅的间隔色
                  color: "#f1f3f8",
                },
              },
              axisLabel: {
                fontSize: 14,
                color: "#666",
                // margin: 8,
                formatter: function (value) {
                  var str = "";
                  var num = 4; //每行显示字数
                  var valLength = value.length; //该项x轴字数
                  var rowNum = Math.ceil(valLength / num); // 行数

                  if (rowNum > 1) {
                    for (var i = 0; i < rowNum; i++) {
                      var temp = "";
                      var start = i * num;
                      var end = start + num;

                      temp = value.substring(start, end) + "\n";
                      str += temp;
                    }
                    return str;
                  } else {
                    return value;
                  }
                },
              },
              axisLine: {
                lineStyle: {
                  type: "solid",
                  color: "#277d95", //左边线的颜色
                  width: "1", //坐标线的宽度
                },
              },
              data: xAxisData,
            },
          ],
          yAxis: [
            {
              type: "value",
              scale: true,
              name: "",
              axisLine: {
                show: true,
              },
              axisTick: {
                show: false,
              },
              splitLine: {
                lineStyle: {
                  // type: "dashed",
                  color: "#f1f3f8",
                },
              },
              axisLabel: {
                fontSize: 14,
                color: "#666",
                // margin: 12
              },
              axisLine: {
                lineStyle: {
                  color: "#277d95",
                  width: 1,
                },
              },
              min: 0,
              boundaryGap: [0.2, 0.2],
            },
          ],
          series: [
            {
              name: "无抑郁",
              type: "bar",
              //   itemStyle: {
              //       color: "#16d0c8",
              //       // borderRadius: [6, 6, 6, 6],
              //   },
              barWidth: "12%",
              yAxisIndex: 0,
              data: seriesData01,
            },
            {
              name: "轻微至轻度抑郁",
              type: "bar",
              //   itemStyle: {
              //       color: "#ff5b82",
              //       // borderRadius: [6, 6, 6, 6],
              //   },
              barWidth: "12%",
              yAxisIndex: 0,
              data: seriesData02,
            },
            {
              name: "中度至重度抑郁",
              type: "bar",
              //   itemStyle: {
              //       color: "#ff5b82",
              //       // borderRadius: [6, 6, 6, 6],
              //   },
              barWidth: "12%",
              yAxisIndex: 0,
              data: seriesData03,
            },
            {
              name: "重度抑郁",
              type: "bar",
              //   itemStyle: {
              //       color: "#ff5b82",
              //       // borderRadius: [6, 6, 6, 6],
              //   },
              barWidth: "12%",
              yAxisIndex: 0,
              data: seriesData04,
            },
          ],
        };
        if (this.dom != null && this.dom != "" && this.dom != undefined) {
          this.dom.dispose();
        }
        this.dom = echarts.init(this.$refs.dom);
        this.dom.setOption(option);
        on(window, "resize", this.resize);
      });
    },
  },

  beforeDestroy() {
    off(window, "resize", this.resize);
  },
};
</script>
